/* SMT-V138-HOME-POLISH */
(() => {
  'use strict';

  const root = document.getElementById('smt-v114-root');
  if (!root || root.dataset.smtV138Ready === 'true') return;
  root.dataset.smtV138Ready = 'true';

  const setupTicker = () => {
    const track = root.querySelector('.announcement__track');
    if (!track) return;
    track.querySelectorAll('[data-smt-v138-ticker-clone]').forEach((node) => node.remove());
    const source = track.querySelector('.ticker__group');
    if (!source) return;

    window.requestAnimationFrame(() => {
      const width = Math.ceil(source.getBoundingClientRect().width);
      if (!width) return;
      const copies = Math.max(2, Math.ceil(window.innerWidth / width) + 2);
      for (let index = 1; index < copies; index += 1) {
        const clone = source.cloneNode(true);
        clone.dataset.smtV138TickerClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      track.style.setProperty('--smt-v138-ticker-shift', `-${width}px`);
      track.style.setProperty('--smt-v138-ticker-duration', `${Math.max(18, width / 42).toFixed(2)}s`);
    });
  };

  setupTicker();
  let resizeTimer = 0;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(setupTicker, 180);
  }, { passive: true });

  const productsSection = root.querySelector('#products');
  const grid = productsSection ? productsSection.querySelector('.product-grid') : null;
  const cards = grid ? Array.from(grid.querySelectorAll('.product-card')).slice(0, 3) : [];
  if (!productsSection || !grid || !cards.length) return;

  const message = document.createElement('div');
  message.className = 'smt-v138-product-message';
  message.setAttribute('role', 'status');
  message.setAttribute('aria-live', 'polite');
  message.hidden = true;
  grid.before(message);

  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
  let requestNumber = 0;

  const normalizeUrl = (value) => {
    if (!value) return '';
    if (typeof value === 'object') value = value.url || value.src || '';
    if (String(value).startsWith('//')) return `${window.location.protocol}${value}`;
    return String(value);
  };

  const productImage = (product) => normalizeUrl(
    product.image ||
    product.featured_image ||
    (Array.isArray(product.images) ? product.images[0] : '')
  );  const imageUrlWithWidth = (value, width) => {
    const normalized = normalizeUrl(value);
    if (!normalized) return '';
    try {
      const parsed = new URL(normalized, window.location.origin);
      if (!/cdn\.shopify\.com|\/cdn\/shop\//i.test(parsed.hostname + parsed.pathname)) return normalized;
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (error) {
      return normalized;
    }
  };

  const setResponsiveImage = (img, value) => {
    const isMobile = window.matchMedia('(max-width: 780px)').matches;
    const widths = isMobile ? [320, 480, 640, 720] : [480, 640, 720, 960];
    img.src = imageUrlWithWidth(value, isMobile ? 640 : 960);
    img.srcset = widths.map((width) => imageUrlWithWidth(value, width) + ' ' + width + 'w').join(', ');
    img.sizes = '(max-width: 780px) calc(100vw - 24px), 33vw';
  };


  const productUrl = (product) => {
    if (product.url) return product.url;
    if (product.handle) return `${shopRoot}products/${encodeURIComponent(product.handle)}`;
    return `${shopRoot}collections/all`;
  };

  const productPrice = (product) => {
    let value = product.price;
    if ((value === undefined || value === null || value === '') && Array.isArray(product.variants) && product.variants[0]) {
      value = product.variants[0].price;
    }
    if (value && typeof value === 'object') value = value.amount || value.price || '';
    if (typeof value === 'number' || /^\d+(?:\.\d+)?$/.test(String(value || ''))) {
      const number = Number(value);
      if (Number.isFinite(number)) {
        return new Intl.NumberFormat('tr-TR', { style: 'currency', currency }).format(number);
      }
    }
    return String(value || 'Fiyat icin inceleyin');
  };

  const setMessage = (text) => {
    message.textContent = text || '';
    message.hidden = !text;
  };

  const setLoading = (loading) => {
    productsSection.classList.toggle('is-smt-v138-loading', loading);
    productsSection.setAttribute('aria-busy', String(loading));
  };

  const hydrateCard = (card, product) => {
    const image = productImage(product);
    if (!image) return false;
    const url = productUrl(product);
    const title = String(product.title || 'SMT urunu');
    card.hidden = false;
    card.dataset.realDataReady = 'true';

    const media = card.querySelector('.product-card__media');
    if (media) {
      media.setAttribute('href', url);
      media.setAttribute('aria-label', `${title} urununu incele`);
      media.querySelectorAll('picture, img, svg, .cushion-art, .cushion-art--product').forEach((node) => node.remove());
      const img = document.createElement('img');
      img.className = 'smt-v138-product-image';
      setResponsiveImage(img, image);
      img.alt = title;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.prepend(img);
    }

    const heading = card.querySelector('.product-card__intro h3, .product-card__body h3');
    if (heading) heading.textContent = title;
    const description = card.querySelector('.product-card__intro p');
    if (description) description.textContent = product.product_type || product.vendor || 'SMT urun secimi';
    const kicker = card.querySelector('.product-kicker');
    if (kicker) kicker.textContent = 'SITE URUNU';
    const badge = card.querySelector('.product-badge');
    if (badge) badge.textContent = 'SECILMIS URUN';
    const price = card.querySelector('.product-price strong');
    if (price) price.textContent = productPrice(product);
    card.querySelectorAll('a.product-detail-link, .product-actions a').forEach((link) => link.setAttribute('href', url));
    return true;
  };

  const renderProducts = (products, emptyMessage) => {
    const usable = (Array.isArray(products) ? products : []).filter((product) => productImage(product)).slice(0, cards.length);
    cards.forEach((card, index) => {
      if (usable[index]) hydrateCard(card, usable[index]);
      else card.hidden = true;
    });
    grid.hidden = usable.length === 0;
    setMessage(usable.length ? '' : emptyMessage);
    return usable.length;
  };

  const fetchJson = async (url) => {
    const response = await window.fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  };

  const loadFeaturedProducts = async () => {
    const currentRequest = ++requestNumber;
    setLoading(true);
    try {
      const data = await fetchJson(`${shopRoot}collections/all/products.json?limit=12`);
      if (currentRequest !== requestNumber) return;
      renderProducts(data.products || [], 'Sitede gosterilecek urun bulunamadi.');
    } catch (error) {
      if (currentRequest !== requestNumber) return;
      grid.hidden = false;
      cards.forEach((card) => { card.hidden = false; });
      setMessage('Urunler su anda yuklenemedi. Lutfen tekrar deneyin.');
    } finally {
      if (currentRequest === requestNumber) setLoading(false);
    }
  };

  const searchProducts = async (query) => {
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '10');
    params.set('resources[options][unavailable_products]', 'hide');
    params.set('resources[options][fields]', 'title,product_type,tag,vendor,variants.title');
    const data = await fetchJson(`${shopRoot}search/suggest.json?${params.toString()}`);
    return (((data || {}).resources || {}).results || {}).products || [];
  };

  /* SMT-V140-BRAND-ONLY-SEARCH */
  const loadVehicleProducts = async (vehicle) => {
    if (!vehicle || !vehicle.brand || !vehicle.model) return;
    const currentRequest = ++requestNumber;
    const selectedDetail = [vehicle.model, vehicle.year].filter(Boolean).join(' \u2022 ');
    setLoading(true);
    setMessage(`${vehicle.brand} markas\u0131 i\u00E7in \u00FCr\u00FCnler aran\u0131yor...`);
    try {
      const products = await searchProducts(vehicle.brand);
      if (currentRequest !== requestNumber) return;
      const renderedCount = renderProducts(products, 'Bu model i\u00E7in \u00FCr\u00FCn bulunamad\u0131');
      if (renderedCount) {
        const compatibilityText = selectedDetail
          ? `${selectedDetail} uyumlulu\u011Fu ma\u011Fazada teyit edilir.`
          : 'Model uyumlulu\u011Fu ma\u011Fazada teyit edilir.';
        setMessage(`${vehicle.brand} markas\u0131 i\u00E7in \u00FCr\u00FCnler g\u00F6steriliyor. ${compatibilityText}`);
      }
    } catch (error) {
      if (currentRequest !== requestNumber) return;
      grid.hidden = true;
      cards.forEach((card) => { card.hidden = true; });
      setMessage('\u00DCr\u00FCnler \u015Fu anda y\u00FCklenemedi. L\u00FCtfen tekrar deneyin.');
    } finally {
      if (currentRequest === requestNumber) setLoading(false);
    }
  };
  const readVehicle = (prefix) => {
    const idPrefix = prefix ? `${prefix}-` : '';
    const brand = root.querySelector(`#${idPrefix}vehicle-brand`);
    const model = root.querySelector(`#${idPrefix}vehicle-model`);
    const year = root.querySelector(`#${idPrefix}vehicle-year`);
    if (!brand || !model || !year) return null;
    return { brand: brand.value, model: model.value, year: year.value };
  };

  root.addEventListener('click', (event) => {
    const button = event.target.closest('#hero-vehicle-submit, #vehicle-submit');
    if (!button || button.disabled) return;
    const vehicle = readVehicle(button.id === 'hero-vehicle-submit' ? 'hero' : '');
    if (vehicle && vehicle.brand && vehicle.model) loadVehicleProducts(vehicle);
  });

  let savedVehicle = null;
  try {
    savedVehicle = JSON.parse(window.localStorage.getItem('SMT_SELECTED_VEHICLE_V1') || 'null');
  } catch (error) {
    savedVehicle = null;
  }

  if (savedVehicle && savedVehicle.brand && savedVehicle.model) {
    loadVehicleProducts(savedVehicle);
  } else if (window.requestIdleCallback) {
    window.requestIdleCallback(() => loadFeaturedProducts(), { timeout: 2200 });
  } else {
    window.setTimeout(loadFeaturedProducts, 1200);
  }
})();